export const SECOND_IN_MS = 1000;
export const ONE_MINUTE_IN_MS = 60 * SECOND_IN_MS;
export const ONE_HOUR_IN_MS = 60 * ONE_MINUTE_IN_MS;
export const ONE_DAY_IN_MS = 24 * ONE_HOUR_IN_MS;
